import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import './Home.css';
import Type from "./Type";


// import {
//   AiFillGithub,
//   AiOutlineTwitter,
//   AiFillInstagram,
// } from "react-icons/ai";
// import { FaLinkedinIn } from "react-icons/fa";




function Home() {
  return (
     <>
        <Particle />
      <div fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 className="heading">
               <strong className="main-name pr-3"> Hi</strong> <span>There!</span>
               <span className="wave" role="img" aria-labelledby="wave">👋🏻</span>
              </h1>

              <h2 className="heading-name">
               <span className="pr-3">I'M</span>
                <strong className="main-name pr-2"> SHAMIM</strong> <span>ISLAM</span>
              </h2>

              <div class="type-cursor">
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 18 }}>
              <img src={homeLogo} alt="home pic" className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Home;
